import { useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import Breadcrumb from '../../core/components/UI/Breadcrumb'
import useMineralsActions from '../hooks/useMineralsActions'
import { useMineralsContext } from '../context/minerals/mineralsProvider'
import MineralsGrid from '../components/minerals-page/MineralsGrid'
import LoaderMineralsGrid from '../components/minerals-page/LoaderMineralsGrid'
import Pagination from '../../core/components/UI/Pagination'

const links = [
  {
    id: 1,
    label: 'المعادن',
    isActive: true,
    to: '/minerals',
  },
]

export default function MineralsPage() {
  const [searchParams] = useSearchParams()
  const { mineralsState } = useMineralsContext()
  const { getMinerals } = useMineralsActions()

  useEffect(() => {
    getMinerals(searchParams.toString())
  }, [searchParams])

  return (
    <>
      <Breadcrumb links={links} />
      <div className="flex items-center justify-between">
        <Link
          className="flex bg-primary-600 px-4 py-2 font-bold text-white hover:bg-primary-500"
          to={`/minerals/create`}
        >
          إضافة معدن
        </Link>
      </div>
      {mineralsState.isLoading ? (
        <LoaderMineralsGrid />
      ) : (
        <MineralsGrid minerals={mineralsState.minerals} />
      )}
      <Pagination pagination={mineralsState.pagination} />
    </>
  )
}
